import Vue from 'vue';
import App from './App.vue';
// import firebase from 'firebase/app';
import router from './router';
import store from './store';
import axios from 'axios';
import VueAxios from 'vue-axios';
import vuetify from './plugins/vuetify';
import moment from 'moment';
import {firebase,db} from './plugins/firebase';
// @ts-ignore
import FormRules from '@/Lib/FormRules';
// import 'firebase/database';
// import 'firebase/firestore';
// import 'firebase/functions';
Vue.config.productionTip = false;

// const config = {
//   apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
//   authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
//   databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
//   projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
//   storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
//   messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID
// };
//
// firebase.initializeApp(config);

Vue.use(VueAxios, axios);

// Route Guard, verify user is still logged in before navigating to the next location.
router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        next();
      } else {
        next({
          path: '/login',
          query: { redirect: to.fullPath },
        });
      }
    });

  } else {
    next(); // make sure to always call next()!
  }
});
// let db = firebase.firestore();
// if (location.hostname === "localhost") {
//   db.settings({
//     host: "localhost:5003",
//     ssl: false
//   });
//   firebase.functions().useFunctionsEmulator("http://localhost:5001");
// }
Vue.prototype.$firestore = db;
Vue.prototype.$firedb = firebase.database();
Vue.prototype.$moment = moment;
Vue.prototype.$rules = FormRules;
Vue.prototype.$copyToClipBoard = async (text: string) => {
  if (!navigator.clipboard) {
    let textArea = document.createElement("textarea");
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      let successful = document.execCommand('copy');
      if(successful){
        store.dispatch("showSuccess", "Copied to Clipboard!")
      }
    } catch (err) {
      store.dispatch("showError", "An error occurred while trying to copy something.")
    }

    document.body.removeChild(textArea);
    return;
  }
  navigator.clipboard.writeText(text).then(() => {
    store.dispatch("showSuccess", "Copied to Clipboard!")
  }, (err) => {
    store.dispatch("showError", "An error occurred while trying to copy something.")
  });
}
//global components
// @ts-ignore
Vue.component('CardTitle', () => import('./components/general/DialogCard/CardTitle'))
// @ts-ignore
Vue.component('CardActions', () => import('./components/general/DialogCard/CardActions'))
// @ts-ignore
Vue.component('Confirm', () => import('./components/general/ConfirmDialog'))
// @ts-ignore
Vue.component('layout', () => import("./components/viewTemplates/layout"));
new Vue({
  // @ts-ignore
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
